import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Gestione_file_mp3 = (props) => {


    useEffect(() => {
        if (props.play_spunta_ripetuto && props.play_ripetuto) {
            var indice = props.play_indice
            indice++
            props.funzione_play_indice(indice)
            //            function_set_tempo_seek(play_lista[indice])
            props.funzione_play_ripetuto(false)
        }


    }, [props.play_ripetuto, props.play_spunta_ripetuto]);


    const Func_play_q = (nome) => {
        var audio1 = new Audio("./filemp3/" + nome);
        audio1.play();
        console.log('finito q')
        return;
    }

    const Func_play_r = (nome) => {
        var audio2 = new Audio("./filemp3/" + nome);
        audio2.play();
        audio2.addEventListener("ended", function () {
            audio2.currentTime = 0;
            console.log("ended");
        });
        return;
    }

    const Func_play_end = () => {
        var audio2 = new Audio("./filemp3/file1.mp3");
        audio2.play();
        audio2.addEventListener("ended", function () {
            audio2.currentTime = 0;
            console.log("ended");
            props.funzione_play_ripetuto(true)
        });
        return;
    }

    const function_set_tempo_seek = () => {
        console.log(indice)
        var indice = props.indice_vero
        var tempo_per_risposta = parseInt(props.lista_file_mp3[indice].t_r) * 0.6;
        setTimeout(function () { Func_play_q(props.lista_file_mp3[indice].n_q) }, 1000); console.log('fine in start2'); // Update count to be 5 after timeout is scheduled
        setTimeout(function () { Func_play_r(props.lista_file_mp3[indice].n_r) }, (tempo_per_risposta + parseInt(props.lista_file_mp3[indice].t_q)) * 1000); console.log('fine in start3'); // Update 
        setTimeout(function () { Func_play_end() }, (tempo_per_risposta + 5 + parseInt(props.lista_file_mp3[indice].t_q) + parseInt(props.lista_file_mp3[indice].t_r)) * 1000); console.log('fine in start1'); // Update 
    }



    return (
        <div>
            <button onClick={() => function_set_tempo_seek()} > {props.inplay} {props.indice_vero} </button>

        </div>
    )
}
export default Gestione_file_mp3;